export interface User {
  id: number;
  name: string;
  last_name?: string;
  type: string;
  razon_social?: string;
}

export const formatUserName = (user: User): string => {
  if (user.type === 'COMPANY' && user.razon_social) {
    return user.razon_social;
  }
  
  const lastName = user.last_name || '';
  return `${user.name} ${lastName}`.trim();
};

